<div class="failure-modal__container">
  <div class="failure-modal__wrapper">
    <div class="failure-modal__header">{{ data?.title }}</div>
    <div class="failure-modal__close-icon">
      <fa-icon
        [icon]="faTimes"
        mat-dialog-close
        [mat-dialog-close]='false'>
      </fa-icon>
    </div>
  </div>
  @if (data?.body) {
    <div class="failure-modal__body">{{ data?.body }}</div>
  }
</div>